// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tah_I5v4Ok0DLUhEnWbk{background-color:var(--background-primary-inverted-primary);flex-direction:column;width:100%;height:100vh;display:flex}.Tah_I5v4Ok0DLUhEnWbk .gtwKD3Vr6_MzRzKVZlDe{text-align:center}.e86kDr1PTrgcdvvPR5K3{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Tah_I5v4Ok0DLUhEnWbk`,
	"subtitle": `gtwKD3Vr6_MzRzKVZlDe`,
	"successWrap": `e86kDr1PTrgcdvvPR5K3`
};
export default ___CSS_LOADER_EXPORT___;
